export enum UserReportType {
  BUG_TECHNICAL = "BUG_TECHNICAL", // Lỗi kỹ thuật / ứng dụng
  AI_CONTENT = "AI_CONTENT", // Lỗi nội dung / AI trả về sai
  FEATURE_REQUEST = "FEATURE_REQUEST", // Đóng góp ý kiến / tính năng mới
  OTHER = "OTHER", // Khác
}

export enum UserReportStatus {
  PENDING = "PENDING", // Chờ tiếp nhận
  IN_PROGRESS = "IN_PROGRESS", // Đang xử lý
  RESOLVED = "RESOLVED", // Đã giải quyết / Đã sửa lỗi
  REJECTED = "REJECTED", // Từ chối / Không hợp lệ
  CLOSED = "CLOSED", // Đã đóng
}

export interface IUserReport {
  _id: string;
  ticketCode: string;
  userId: string;
  type: UserReportType;
  title: string;
  description: string;
  images?: string[];
  audioUrl?: string;
  audioDuration?: number;
  pageUrl?: string;
  deviceInfo?: {
    userAgent?: string;
    browser?: string;
    os?: string;
    screenResolution?: string;
    appVersion?: string;
  };
  status: UserReportStatus;
  adminResponse?: string;
  handledBy?: {
    _id: string;
    name?: string;
    email?: string;
  };
  resolvedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateUserReportPayload {
  type: UserReportType;
  title: string;
  description: string;
  pageUrl?: string;
  deviceInfo?: Record<string, any>;
  images?: File[];
  audioBlob?: Blob;
  audioDuration?: number;
}

export interface IMyReportsResponse {
  data: IUserReport[];
  total: number;
  page: number;
  limit: number;
}
